import React, { useEffect } from 'react';
import { Box, Image, Mobile, useInView, AspectRatio } from '@stockx/ui';
import { SwitcherLink } from '@app/router';
import useBuildContentstackImageSrc from '@drc/hooks/useBuildContentstackImageSrc';
import { useBannerCollage } from '../../hooks';
import { CollageComponentProps } from '../../types';

const MobileBannerCollage = ({
  collage,
  handleTrackingEvent,
  handleTrackingImpression,
}: CollageComponentProps) => {
  const { bannerCollage } = useBannerCollage(collage);
  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      handleTrackingImpression(trackingEvent);
    }
  }, [inView]);

  const {
    image: { alt, url: imageUrl },
    link: { title, url: linkUrl, urlType },
    trackingEvent,
  } = bannerCollage?.small ?? {};

  const trackingProps = {
    bannerSize: 'Small',
    destination: urlType,
    trackingEvent,
    URL: linkUrl,
  };

  const { imageSrc, imageSrcSet } = useBuildContentstackImageSrc({
    src: imageUrl,
    options: {
      width: 425,
      height: 425,
    },
  });

  return (
    <Mobile>
      <Box width="100%" ref={ref}>
        <SwitcherLink
          as={urlType}
          title={title}
          to={linkUrl}
          onClick={() => handleTrackingEvent(trackingProps)}
        >
          <AspectRatio ratio={1}>
            <Image
              referrerPolicy="origin"
              srcSet={imageSrcSet}
              src={imageSrc}
              alt={alt}
              width="100%"
              height="100%"
              loading="lazy"
            />
          </AspectRatio>
        </SwitcherLink>
      </Box>
    </Mobile>
  );
};

export default MobileBannerCollage;
